import DesSpreNoi from "pages/Des-spreNoi";

export default function DesSpreNoiPage() {
    return <DesSpreNoi />;
}
